import { takeEvery, put } from "redux-saga/effects";
import api from "../../services/api";
import { ENDPOINT } from '../../services/apiUrls';
import { activityPostFinalEdit, attachmentDownloadDelete, inventorySupplierData, getActivityDetail, getFilteredInventoryActivity, getInventorySupplierFetchAll, getRelatedInventoryActivity, saveActivityDetail, submitActivityDetail, uploadActivityAttachment, bulkApprovalSubmit, rejectActivityDetail } from "../slices/inventory";

function* getFilteredActivities(actions: any): any {
  try {
    const response = yield api.request({
      method: `POST`,
      url: ENDPOINT.INVENTORY.filtered_inventory_activity,
      data: actions.payload.dataToSend,
    });

    !response?.code
      ? actions.payload.callback(response)
      : actions.payload.callback(false);
  } catch (error) {
    actions.payload.callback(false);
    console.log(error);
  }
}

function* getActivityDetailSaga(actions?: any): any {
  try {
    const response = yield api.request({
      method: `GET`,
      url: ENDPOINT.INVENTORY.inventory_activity_detail(
        actions.payload.activityId
      ),
    });
    response
      ? actions.payload.callback(response)
      : actions.payload.callback(false);
  } catch (error) {
    console.log(error);
  }
}

function* getRelatedActivities(actions?: any): any {
  try {
    const response = yield api.request({
      method: `GET`,
      url: ENDPOINT.INVENTORY.related_inventory_activity(
        actions.payload.activityId
      ),
    });

    response
      ? actions.payload.callback(response)
      : actions.payload.callback(false);
  } catch (error) {
    console.log(error);
  }
}

function* saveFilteredActivities(actions: any): any {
  try {
    const response = yield api.request({
      method: `POST`,
      url: ENDPOINT.INVENTORY.save_activity_detail(actions.payload.activityId),
      data: actions.payload.dataToSend,
    });

    !response?.code
      ? actions.payload.callback(response)
      : actions.payload.callback(false);
  } catch (error) {
    actions.payload.callback(false);
    console.log(error);
  }
}

function* submitFilteredActivities(actions: any): any {
  try {
    const response = yield api.request({
      method: `POST`,
      url: ENDPOINT.INVENTORY.submit_activity_detail(
        actions.payload.activityId
      ),
    });
    !response?.code
      ? actions.payload.callback(response)
      : actions.payload.callback(false);
  } catch (error) {
    actions.payload.callback(false);
    console.log(error);
  }
}

function* uploadAttachmentToActivity(actions: any): any {
  try {
    const response = yield api.request({
      method: "POST",
      url: ENDPOINT.INVENTORY.upload_attachment_to_activity(
        actions.payload.activityId
      ),
      data: actions.payload.dataToSend,
    });

    !response?.code
      ? actions.payload.callback(response)
      : actions.payload.callback(false);
  } catch (error) {
    actions.payload.callback(false);
    console.log(error);
  }
}

function* activityPostFinalEditSaga(actions: any): any {
  try {
    const response = yield api.request({
      method: "POST",
      url: ENDPOINT.INVENTORY.activity_post_final_edit(),
      data: actions.payload.dataToSend,
    });

    !response?.code
      ? actions.payload.callback(response)
      : actions.payload.callback(false);
  } catch (error) {
    actions.payload.callback(false);
    console.log(error);
  }
}

function* attachmentDownloadDeleteSaga(actions: any): any {
  try {
    const response = yield api.request({
      method: actions.payload.method,
      url: ENDPOINT.INVENTORY.attachment_download_delete(
        actions.payload.activityId,
        actions.payload.attachmentId,
        actions.payload.filename
      ),
    });
    !response?.code
      ? actions.payload.callback(response)
      : actions.payload.callback(false);
  } catch (error) {
    actions.payload.callback(false);
    console.log(error);
  }
}

function* getInventorySupplierSaga(actions?: any): any {
  try {
    const response = yield api.request({
      method: `GET`,
      url: ENDPOINT.INVENTORY.inventory_activity_suppliers(),
    });
    yield put(inventorySupplierData(response));
    response
      ? actions.payload.callback(response)
      : actions.payload.callback(false);
  } catch (error) {
    console.log(error);
  }
}

function* submitBulkApprovalActivities(actions: any): any {
  try {
    const response = yield api.request({
      method: `POST`,
      url: ENDPOINT.INVENTORY.submit_bulk_approval_detail(),
      data: actions.payload,
    });
    !response?.code
      ? actions.payload.callback(response)
      : actions.payload.callback(false);
  } catch (error) {
    actions.payload.callback(false);
    console.log(error);
  }
}

function* rejectInventoryActivity(actions: any): any {
  try {
    const response = yield api.request({
      method: `POST`,
      url: ENDPOINT.INVENTORY.reject_activity_detail(
        actions.payload.activityId
      ),
    });
    !response?.code
      ? actions.payload.callback(response)
      : actions.payload.callback(false);
  } catch (error) {
    actions.payload.callback(false);
    console.log(error);
  }
}

export default function* root() {
  yield takeEvery(getFilteredInventoryActivity.type, getFilteredActivities);
  yield takeEvery(getActivityDetail.type, getActivityDetailSaga);
  yield takeEvery(saveActivityDetail.type, saveFilteredActivities);
  yield takeEvery(submitActivityDetail.type, submitFilteredActivities);
  yield takeEvery(getRelatedInventoryActivity.type, getRelatedActivities);
  yield takeEvery(uploadActivityAttachment.type, uploadAttachmentToActivity);
  yield takeEvery(attachmentDownloadDelete.type, attachmentDownloadDeleteSaga);
  yield takeEvery(activityPostFinalEdit.type, activityPostFinalEditSaga);
  yield takeEvery(getInventorySupplierFetchAll.type, getInventorySupplierSaga);
  yield takeEvery(bulkApprovalSubmit.type, submitBulkApprovalActivities);
  yield takeEvery(rejectActivityDetail.type, rejectInventoryActivity);

}

